var render, staticRenderFns
import script from "./ExcursionList.vue?vue&type=script&lang=js&"
export * from "./ExcursionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('472c7f09')) {
      api.createRecord('472c7f09', component.options)
    } else {
      api.reload('472c7f09', component.options)
    }
    
  }
}
component.options.__file = "module/Vrcci/Excursion/resources/vue/ExcursionList.vue"
export default component.exports